/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { Center, useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      book_Cube026_1: Mesh
      book_Cube026_1_1: Mesh
      book2_Cube024_1: Mesh
      book2_Cube024_1_1: Mesh
      book3_Cube: Mesh
      Book1_Cube025: Mesh
    }
    materials: {
      ['009688']: MeshStandardMaterial
      FFFFFF: MeshStandardMaterial
      FF5722: MeshStandardMaterial
      F44336: MeshStandardMaterial
      ['8BC34A']: MeshStandardMaterial
      DD9944: MeshStandardMaterial
    }
  }

export function Books(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/books.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <Center position-y={4.4}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.book3_Cube.geometry}
          material={materials['8BC34A']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Book1_Cube025.geometry}
          material={materials.DD9944}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.book_Cube026_1.geometry}
          material={materials['009688']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.book_Cube026_1_1.geometry}
          material={materials.FFFFFF}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.book2_Cube024_1.geometry}
          material={materials.FF5722}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.book2_Cube024_1_1.geometry}
          material={materials.F44336}
        />
      </Center>
    </group>
  )
}

useGLTF.preload('/models/books.glb')
